import type { JSX } from 'react'
import { cn } from '#src/cn.ts'

export function IconIntervention({
  className,
}: {
  className?: string
}): JSX.Element {
  return (
    <svg
      className={cn('size-4 shrink-0', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="#949698"
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.59101 9.58053L7.48769 4.79175C7.72142 4.40535 8.27858 4.40535 8.51231 4.79175L11.409 9.58053C11.7265 10.1055 11.153 10.7168 10.6144 10.4275L8.09409 9.07421C8.03528 9.04263 7.96471 9.04263 7.90591 9.07421L5.38559 10.4275C4.84695 10.7168 4.27348 10.1055 4.59101 9.58053Z"></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 8.00195C15 11.8679 11.866 15.002 8 15.002C4.13401 15.002 1 11.8679 1 8.00195C1 4.13596 4.13401 1.00195 8 1.00195C11.866 1.00195 15 4.13596 15 8.00195ZM13.5 8.00195C13.5 11.0395 11.0376 13.502 8 13.502C4.96243 13.502 2.5 11.0395 2.5 8.00195C2.5 4.96439 4.96243 2.50195 8 2.50195C11.0376 2.50195 13.5 4.96439 13.5 8.00195Z"
      ></path>
    </svg>
  )
}
